import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

const Certificate = (props) => (
  <Svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M5.46 10.98c-.44 0-.8.36-.8.8 0 .44.36.8.8.8H11c.44 0 .8-.36.8-.8 0-.44-.36-.8-.8-.8H5.46ZM17.8 8.22c0-.44-.36-.8-.8-.8H5.46c-.44 0-.8.36-.8.8 0 .44.36.8.8.8H17c.44 0 .8-.36.8-.8Z"
      fill="#fff"
    />
    <Path
      d="M19.11 4H4.89C3.29 4 2 5.29 2 6.89v8.22C2 16.71 3.29 18 4.89 18h8.33l.24-1.6H4.89c-.71 0-1.29-.58-1.29-1.29V6.89c0-.71.58-1.29 1.29-1.29h14.22c.71 0 1.29.58 1.29 1.29v8.22c0 .65-.5 1.18-1.13 1.26l.28 1.59c1.39-.21 2.45-1.4 2.45-2.85V6.89C22 5.29 20.71 4 19.11 4Z"
      fill="#fff"
    />
    <Path
      d="M19.4 13.39c0-1.66-1.35-3.01-3.01-3.01-1.66 0-3.01 1.35-3.01 3.01 0 .74.28 1.41.72 1.94l-.46 3.87c-.03.23.07.47.25.62.13.11.29.16.45.16.07 0 .14-.01.21-.03l1.84-.56 1.84.56c.23.07.47.02.65-.13.18-.15.27-.39.25-.62l-.47-3.86c.45-.53.73-1.2.73-1.95h.01Zm-2.8 4.59a.715.715 0 0 0-.41 0l-1.02.31.24-2.07c.31.11.63.18.98.18s.66-.07.97-.17l.25 2.07-1.01-.31v-.01Zm-.21-2.8c-.97 0-1.76-.79-1.76-1.76s.79-1.76 1.76-1.76 1.76.79 1.76 1.76-.79 1.76-1.76 1.76Z"
      fill="#fff"
    />
  </Svg>
)

export default Certificate
